<table class="table" *ngIf="tableData">
  <tr
    class="table-row"
    *ngFor="let row of tableData; let even = even; let odd = odd"
    [ngClass]="{ odd: odd, even: even }"
  >
    <td class="table-data" *ngFor="let field of row">
      {{ field }}
    </td>
  </tr>
</table>
